<!--
  --
  -- シンプルなチェックボックス
  --
  -- 余計な余白やヘルパーテキスト領域などを除く設定をした v-checkbox
  --
  -->
<template>
  <div>
    <v-checkbox
      dense hide-details class="mt-0 pt-0"
      :label="label"
      :value="value"
      :input-value="inputValue"
      @change="$emit('change', $event)"
    />
  </div>
</template>

<script>
export default {
  name: 'CCheckbox',
  model: {
    prop: 'inputValue',
    event: 'change'
  },
  props: {
    inputValue: {
      type: [Boolean, Number, String, Array, Object],
      default: 0
    },
    label: {
      type: String,
      default: ''
    },
    value: {}
  }
}
</script>
